import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithTokenHandling } from '../baseQuery';
import { buildSearchParamsAuto } from '../utils';
import { EDUCATION_TAG_TYPE } from './constants';

export const educationApi = createApi({
  reducerPath: 'educationApi',
  baseQuery: baseQueryWithTokenHandling,
  tagTypes: [EDUCATION_TAG_TYPE],
  endpoints: (builder) => ({
    getEducationNetwork: builder.query<MedScout.PaginatedResponse & { results: any[] }, { id: string; [key: string]: any }>({
      query: ({ id, ...rest }) => {
        const params = buildSearchParamsAuto(rest);
        return {
          url: `v1/hcp/${id}/education-network?${params}`,
          method: 'GET',
        };
      },
      providesTags: (result, error, { id }) => [
        { type: EDUCATION_TAG_TYPE, id },
      ],
    }),
  }),
});

export const {
  useGetEducationNetworkQuery,
} = educationApi;
